import React from 'react';
import { useReframe } from 'nike-re-framejs';
import SelectMe from 'react-select-me/lib/ReactSelectMe';
import clsx from 'clsx';
import ChevronIcon from '../../icons/ChevronDownIcon';

import './Select.less';

export function Select({
    field,
    options,
    disabled,
    className
}: {
    field;
    options: { value: string | number; label: string }[];
    disabled?: boolean;
    className?;
}) {
    const { deref } = useReframe();
    const val = deref(field.getStrValue());
    const initialValue = options.filter(o => o.value === val)[0];
    return (
        <div className={clsx(className, 'py-5')}>
            <SelectMe
                options={options}
                listPosition="bottom"
                onChange={v => field.setStrValue(v.value, true)}
                disabled={disabled}
                value={initialValue}
                iconRenderer={iconRenderer}
            />
        </div>
    );
}

const iconRenderer = isOpened => (
    <div className="select-icon">
        <ChevronIcon className={clsx({ up: isOpened })} />
    </div>
);
